var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full h-full flex flex-col",staticStyle:{"font-size":"0.875rem"}},[(_vm.canEditCommunity && _vm.selection)?_c('ObjectEditor',{attrs:{"id":_vm.selection}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }